// Copyright (c) 2021 Deere & Company

import LeadAccount from './lead-account';
import t from 'tcomb';

const DealerHierarchyLeadAccount = t.struct({
    leadAccountId: t.String,
    leadAccounts: t.list(LeadAccount, 'LeadAccounts')
}, {
    name: 'DealerHierarchyLeadAccount',
    strict: true
});

export const getDefaultState = () => new DealerHierarchyLeadAccount({
    leadAccountId: '',
    leadAccounts: []
});

export default DealerHierarchyLeadAccount;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-lead-account.js